export const APP_IS_DONE_LOADING = 'APP_IS_DONE_LOADING';
export const endLoading = () => ({type: APP_IS_DONE_LOADING });
